// 清音数据： https://www.sojson.com/editor.html

/* eslint-disable */

const voiceless = {
  'column': ['あ', 'い', 'う', 'え', 'お'],
  'row': {
    'key': ['あ', 'か', 'さ', 'た', 'な', 'は', 'ま', 'や', 'ら', 'わ', ''],
    'value': [
      [
        {
          'hiragana': 'あ', // 平假名
          'katakana': 'ア', // 片假名
          'romaji': 'a', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '安的草书 [安]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '阿的楷书 [阿]',
          },
          'example': {
            'text': 'あい①愛',
            'paraphrase': '[名词] 爱恋、爱情',
          }
        },
        {
          'hiragana': 'い', // 平假名
          'katakana': 'イ', // 片假名
          'romaji': 'i', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '以的草书[以]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '伊的楷书[伊]',
          },
          'example': {
            'text': 'いちもく⓪②一目',
            'paraphrase': '[名词]一只眼',
          }
        },
        {
          'hiragana': 'う', // 平假名
          'katakana': 'ウ', // 片假名
          'romaji': 'u', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '宇的草书[宇]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '宇的楷书[宇]',
          },
          'example': {
            'text': 'うどん⓪饂飩',
            'paraphrase': '[名词]切面、面条',
          }
        },
        {
          'hiragana': 'え', // 平假名
          'katakana': 'エ', // 片假名
          'romaji': 'e', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '衣的草书[衣]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '江的楷书[江]',
          },
          'example': {
            'text': 'えさ②餌',
            'paraphrase': '[名词]饵食',
          }
        },
        {
          'hiragana': 'お', // 平假名
          'katakana': 'オ', // 片假名
          'romaji': 'o', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '於的草书[於]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '於的楷书[於]',
          },
          'example': {
            'text': 'おとこ③男',
            'paraphrase': '[名词]男性',
          }
        },
      ],
      [
        {
          'hiragana': 'か', // 平假名
          'katakana': 'カ', // 片假名
          'romaji': 'ka', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '加的草书[加]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '加的楷书[加]',
          },
          'example': {
            'text': 'かみ⓪髪',
            'paraphrase': '[名词]头发',
          }
        },
        {
          'hiragana': 'き', // 平假名
          'katakana': 'キ', // 片假名
          'romaji': 'ki', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '机的草书[机]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '机的楷书[机]',
          },
          'example': {
            'text': 'きかい⓪②機会',
            'paraphrase': '[名词]机会',
          }
        },
        {
          'hiragana': 'く', // 平假名
          'katakana': 'ク', // 片假名
          'romaji': 'ku', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '久的草书[久]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '久的楷书[久]',
          },
          'example': {
            'text': 'くむ①組む',
            'paraphrase': '[动词]合伙，组队',
          }
        },
        {
          'hiragana': 'け', // 平假名
          'katakana': 'ケ', // 片假名
          'romaji': 'ke', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '计的草书[计]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '介的楷书[介]',
          },
          'example': {
            'text': 'けさ①今朝',
            'paraphrase': '[名词]今早',
          }
        },
        {
          'hiragana': 'こ', // 平假名
          'katakana': 'コ', // 片假名
          'romaji': 'ko', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '己的草书[己]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '己的楷书[己]',
          },
          'example': {
            'text': 'こい①恋',
            'paraphrase': '[名词]恋爱',
          }
        },
      ],
      [
        {
          'hiragana': 'さ', // 平假名
          'katakana': 'サ', // 片假名
          'romaji': 'sa', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '左的草书[左]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '散的楷书[散]',
          },
          'example': {
            'text': 'さくら⓪桜',
            'paraphrase': '[名词]樱花',
          }
        },
        {
          'hiragana': 'し', // 平假名
          'katakana': 'シ', // 片假名
          'romaji': 'shi', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '之的草书[之]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '之的楷书[之]',
          },
          'example': {
            'text': 'しし①獅子',
            'paraphrase': '[名词]狮子',
          }
        },
        {
          'hiragana': 'す', // 平假名
          'katakana': 'ス', // 片假名
          'romaji': 'su', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '寸的草书[寸]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '须的楷书[须]',
          },
          'example': {
            'text': 'すし②①寿司',
            'paraphrase': '[名词]寿司',
          }
        },
        {
          'hiragana': 'せ', // 平假名
          'katakana': 'セ', // 片假名
          'romaji': 'se', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '世的草书[世]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '世的楷书[世]',
          },
          'example': {
            'text': 'せかい①世界',
            'paraphrase': '[名词]世界',
          }
        },
        {
          'hiragana': 'そ', // 平假名
          'katakana': 'ソ', // 片假名
          'romaji': 'so', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '曾的草书[曾]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '曾的楷书[曾]',
          },
          'example': {
            'text': 'そら①空',
            'paraphrase': '[名词]天空',
          }
        },
      ],
      [
        {
          'hiragana': 'た', // 平假名
          'katakana': 'タ', // 片假名
          'romaji': 'ta', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '太的草书[太]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '多的楷书[多]',
          },
          'example': {
            'text': 'たま⓪玉',
            'paraphrase': '[名词]球，镜片，硬币',
          }
        },
        {
          'hiragana': 'ち', // 平假名
          'katakana': 'チ', // 片假名
          'romaji': 'chi', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '知的草书[知]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '千的楷书[千]',
          },
          'example': {
            'text': 'ちち①②父',
            'paraphrase': '[名词]爸爸',
          }
        },
        {
          'hiragana': 'つ', // 平假名
          'katakana': 'ツ', // 片假名
          'romaji': 'tsu', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '川的草书[川]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '川的楷书[川]',
          },
          'example': {
            'text': 'つち②土',
            'paraphrase': '[名词]土地',
          }
        },
        {
          'hiragana': 'て', // 平假名
          'katakana': 'テ', // 片假名
          'romaji': 'te', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '天的草书[天]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '天的楷书[天]',
          },
          'example': {
            'text': 'て①手',
            'paraphrase': '[名词]手',
          }
        },
        {
          'hiragana': 'と', // 平假名
          'katakana': 'ト', // 片假名
          'romaji': 'to', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '止的草书[止]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '止的楷书[止]',
          },
          'example': {
            'text': 'とぶ⓪飛ぶ',
            'paraphrase': '[动词]飞',
          }
        },
      ],
      [
        {
          'hiragana': 'な', // 平假名
          'katakana': 'ナ', // 片假名
          'romaji': 'na', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '奈的草书[奈]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '奈的楷书[奈]',
          },
          'example': {
            'text': 'なな①七',
            'paraphrase': '[数词]七',
          }
        },
        {
          'hiragana': 'に', // 平假名
          'katakana': 'ニ', // 片假名
          'romaji': 'ni', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '仁的草书[仁]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '仁的楷书[仁]',
          },
          'example': {
            'text': 'におい②匂い',
            'paraphrase': '[名词]气味',
          }
        },
        {
          'hiragana': 'ぬ', // 平假名
          'katakana': 'ヌ', // 片假名
          'romaji': 'nu', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '奴的草书[奴]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '奴的楷书[奴]',
          },
          'example': {
            'text': 'ぬく⓪抜く',
            'paraphrase': '[动词]抽出，除掉',
          }
        },
        {
          'hiragana': 'ね', // 平假名
          'katakana': 'ネ', // 片假名
          'romaji': 'ne', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '祢的草书[祢]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '祢的楷书[祢]',
          },
          'example': {
            'text': 'ねこ①猫',
            'paraphrase': '[名词]猫',
          }
        },
        {
          'hiragana': 'の', // 平假名
          'katakana': 'ノ', // 片假名
          'romaji': 'no', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '乃的草书[乃]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '乃的楷书[乃]',
          },
          'example': {
            'text': 'のむ①飲む',
            'paraphrase': '[动词]吃，喝',
          }
        },
      ],
      [
        {
          'hiragana': 'は', // 平假名
          'katakana': 'ハ', // 片假名
          'romaji': 'ha', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '波的草书 [波]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '八的楷书 [八]',
          },
          'example': {
            'text': 'はな②花',
            'paraphrase': '[名词] 花',
          }
        },
        {
          'hiragana': 'ひ', // 平假名
          'katakana': 'ヒ', // 片假名
          'romaji': 'hi', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '比的草书 [比]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '比的楷书 [比]',
          },
          'example': {
            'text': 'ひま⓪暇',
            'paraphrase': '[名词]时间，工夫',
          }
        },
        {
          'hiragana': 'ふ', // 平假名
          'katakana': 'フ', // 片假名
          'romaji': 'fu', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '不的草书 [不]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '不的楷书 [不]',
          },
          'example': {
            'text': 'ふい⓪不意',
            'paraphrase': '[名词]冷不防，突然',
          }
        },
        {
          'hiragana': 'へ', // 平假名
          'katakana': 'ヘ', // 片假名
          'romaji': 'he', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '部的草书 [部]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '部的楷书 [部]',
          },
          'example': {
            'text': 'へた②下手',
            'paraphrase': '[形容动词]笨拙，不高明',
          }
        },
        {
          'hiragana': 'ほ', // 平假名
          'katakana': 'ホ', // 片假名
          'romaji': 'ho', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '保的草书 [保]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '保的楷书 [保]',
          },
          'example': {
            'text': 'ほうほう⓪方法',
            'paraphrase': '[名词]方法，法子',
          }
        },
      ],
      [
        {
          'hiragana': 'ま', // 平假名
          'katakana': 'マ', // 片假名
          'romaji': 'ma', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '末的草书 [末]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': ' 末的楷书[末]',
          },
          'example': {
            'text': 'まいる①参る',
            'paraphrase': '[动词]去，来；参拜',
          }
        },
        {
          'hiragana': 'み', // 平假名
          'katakana': 'ミ', // 片假名
          'romaji': 'mi', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': ' 美的草书[美]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '三的楷书[三]',
          },
          'example': {
            'text': 'みみ②耳',
            'paraphrase': '[名词] 耳朵',
          }
        },
        {
          'hiragana': 'む', // 平假名
          'katakana': 'ム', // 片假名
          'romaji': 'mu', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '武的草书[武]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '牟的楷书[牟]',
          },
          'example': {
            'text': 'むじ①無地',
            'paraphrase': '[名词] 素色',
          }
        },
        {
          'hiragana': 'め', // 平假名
          'katakana': 'メ', // 片假名
          'romaji': 'me', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '女的草书[女]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '女的楷书[女]',
          },
          'example': {
            'text': 'めす②雌',
            'paraphrase': '[名词] 雌性',
          }
        },
        {
          'hiragana': 'も', // 平假名
          'katakana': 'モ', // 片假名
          'romaji': 'mo', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '毛的草书[毛]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '毛的楷书[毛]',
          },
          'example': {
            'text': 'もう①毛',
            'paraphrase': '[名词] 毛发，头发',
          }
        },
      ],
      [
        {
          'hiragana': 'や', // 平假名
          'katakana': 'ヤ', // 片假名
          'romaji': 'ya', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '也的草书[也]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '也的楷书[也]',
          },
          'example': {
            'text': 'やちん①家賃',
            'paraphrase': '[名词] 房租',
          }
        },
        {},
        {
          'hiragana': 'ゆ', // 平假名
          'katakana': 'ユ', // 片假名
          'romaji': 'yu', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '由的草书[由]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '由的楷书[由]',
          },
          'example': {
            'text': 'ゆき②雪',
            'paraphrase': '[名词] 雪',
          }
        },
        {},
        {
          'hiragana': 'よ', // 平假名
          'katakana': 'ヨ', // 片假名
          'romaji': 'yo', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '与的草书[与]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '与的楷书[与]',
          },
          'example': {
            'text': 'ようじ⓪用事',
            'paraphrase': '[名词] 事，事情',
          }
        },
      ],
      [
        {
          'hiragana': 'ら', // 平假名
          'katakana': 'ラ', // 片假名
          'romaji': 'ra', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '良的草书[良]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '良的楷书[良]',
          },
          'example': {
            'text': 'らく②①楽',
            'paraphrase': '[形容动词]快乐，舒适',
          }
        },
        {
          'hiragana': 'り', // 平假名
          'katakana': 'リ', // 片假名
          'romaji': 'ri', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '利的草书[利]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '利的楷书[利]',
          },
          'example': {
            'text': 'りかい①理解',
            'paraphrase': '[动词] 理解，了解',
          }
        },
        {
          'hiragana': 'る', // 平假名
          'katakana': 'ル', // 片假名
          'romaji': 'ru', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '留的草书[留]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '流的楷书[流]',
          },
          'example': {
            'text': 'るい①類',
            'paraphrase': '[名词] 种类，类型',
          }
        },
        {
          'hiragana': 'れ', // 平假名
          'katakana': 'レ', // 片假名
          'romaji': 're', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '礼的草书[礼]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '礼的楷书[礼]',
          },
          'example': {
            'text': 'れい①⓪礼',
            'paraphrase': '[名词] 礼貌，礼仪',
          }
        },
        {
          'hiragana': 'ろ', // 平假名
          'katakana': 'ロ', // 片假名
          'romaji': 'ro', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '吕的草书[吕]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '吕的楷书[吕]',
          },
          'example': {
            'text': 'ろじ①路地',
            'paraphrase': '[名词] 胡同，小巷',
          }
        },
      ],
      [
        {
          'hiragana': 'わ', // 平假名
          'katakana': 'ワ', // 片假名
          'romaji': 'wa', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '和的草书[和]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '和的楷书[和]',
          },
          'example': {
            'text': 'わらう⓪笑う',
            'paraphrase': '[五段活用] 笑',
          }
        },
        {},
        {},
        {},
        {
          'hiragana': 'を', // 平假名
          'katakana': 'ヲ', // 片假名
          'romaji': 'wo', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '远的草书[远]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '乎的楷书[乎]',
          },
          'example': {
            'text': '',
            'paraphrase': '',
          }
        },
      ],
      [
        {
          'hiragana': 'ん', // 平假名
          'katakana': 'ン', // 片假名
          'romaji': 'n', // 罗马音
          'hiraganaOrigin': { // 平假名起源
            'img': '',
            'text': '无的草书[无]',
          },
          'katakanaOrigin': { // 片假名起源
            'img': '',
            'text': '尔的楷书[尔]',
          },
          'example': {
            'text': 'にんげん⓪人間',
            'paraphrase': '[名词] 人，人类',
          }
        }
      ]
    ],
  }
};

export default voiceless;
